import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvService {

  constructor() { }
  public apiUrl = "http://77.232.99.142:8081/api"
  public AndroidAppLink = "https://play.google.com/store/apps/details?id=com.family.care.hospital";
  public IOSAppLink = "https://apps.apple.com/app/fch/id1668578877";
  public APIAuthorizationKey = "oWbeovXhz9c9-7PwfAhSm1-4y5N16W_Ua-9hkJzllOv0b-35c86e1bd33c";
  public WebUIURL = "http://localhost:4200/";



public SpecialtiesCount = "30";
 public HealthcareFacilitiesCount = "30";
  public OperationalCitiesCount = "30";
 public StaffMembersCount = "350";
 public BedsCount = "200";
   public AnnualPatientVisitsCount = "120M";

}
